import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    MenuItem,
    TextField,
} from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Tree from "rc-tree";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";
import { isObject } from "lodash";
import { SystemDataListArray } from "../../../../constants/constantList";
import { api } from "../../../../redux/api";
import { Loader } from "../../../../utils/loader";

const API_ENDPOINTS = {
    sessionValue: api.endpoints.get_session_var_names,
    accountData: api.endpoints.getAccountData,
}

const VALUE_LIST = {
    systemData: SystemDataListArray
}

const DIALOG_TITLE = {
    accountData: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_TIT_ACCOUNT_DATA'),
    sessionValue: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD'),
    systemData: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_TIT_SYSTEM_DATA'),
    workflowSessionValue: t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD2_TIT")
}

const DIALOG_DESC_SHORT = {
    accountData: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_DESC_ACCOUNT_DATA'),
    sessionValue: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_DESC'),
    systemData: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_DESC_SYSTEM_DATA'),
    workflowSessionValue: t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_DESC")
}

const DIALOG_DESC_LONG = {
    accountData: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_MSG_ACCOUNT_DATA'),
    sessionValue: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_MSG'),
    systemData: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_MSG_SYSTEM_DATA'),
    workflowSessionValue: t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_MSG")
}

const AddWorkflowSessionValuesModal2 = ({ openModal, handleClose1, handleClose2, resetStates, selectedTemplate, valueHandler, sourceType, showSelection, previousValue }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [value, setValue] = useState('');
    const [actions, setActions] = useState({
        back: true,
        next: false,
        finish: false,
    });
    const { user, account } = useSelector((state) => state.queryParams);
    const [treeData, setTreeData] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (previousValue && showSelection) setValue(previousValue)
        else setValue('');

        return () => {
            setValue('');
            setSelectedValue('');
        }

    }, [previousValue])

    const iconRender = (node) => {
        return (
            <span
                className={node?.ICON_DISPLAY}
            ></span>
        );
    };

    const switcherIcon = (obj) => {
        if (obj.isLeaf) return;
        if (obj.expanded) return <ArrowDropDownIcon />;
        else return <ArrowRightIcon sx={{ color: "#666666" }} />;
    };

    const onExpand = (expandedKeys) => {
        setExpandedKeys(expandedKeys);
    };


    const dataToRcTree = (data, key = 'ws', parentId) => {
        if (!data?.length && isObject(data) && !Object.keys(data)?.length) return [];
        if (sourceType === "sessionValue") {
            return data.map((ele, idx) => {
                const newKey = `${key}-${idx}`;
                return {
                    key: newKey,
                    title: ele?.text,
                    ICON_DISPLAY: ele?.iconName?.toUpperCase() || '',
                    children: dataToRcTree(ele?.chlid || ele?.children || [], newKey, ele?.id || parentId),
                    data: ele?.data,
                    WF_ITEM_ID: ele?.id || parentId,
                }
            })
        } else if (sourceType === "accountData") {
            return data.map((ele, idx) => {
                const newKey = `${key}-${idx}`;
                const title = Object.keys(ele)[0];
                return {
                    key: newKey,
                    title: title,
                    ICON_DISPLAY: 'SESSION_DATA',
                    data: "ACCOUNT_DATA",
                    mapName: title
                }
            })
        } else if (sourceType === "systemData") {
            return Object.keys(data).map((ele, idx) => {
                const newKey = `${key}-${idx}`;
                const title = t(ele);
                return {
                    key: newKey,
                    title: title,
                    ICON_DISPLAY: 'SESSION_DATA',
                    data: "SYSTEM_DATA",
                    mapName: ele
                }
            })
        }
    }

    const onSelect = (selectedKeys, info) => {
        setSelectedKeys([info.node.key]);
        if (sourceType === "sessionValue" && info?.node?.data || info?.node?.ICON_DISPLAY === 'BLACK_DOT') {
            setActions(prev => { return { ...prev, finish: true } });
            setSelectedValue({
                WF_ITEM_LOCATION: info?.node?.data,
                WF_ITEM_ID: info?.node?.WF_ITEM_ID,
                MAPNAME: info?.node?.localizedString || info?.node?.title,
            })
        } else if (["accountData", "systemData"].includes(sourceType)) {
            setActions(prev => { return { ...prev, finish: true } });
            setSelectedValue({
                type: info.node?.data,
                MAPNAME: info.node.title,
            })
        }
        else {
            setActions(prev => { return { back: true, next: false, finish: false, } });
            setSelectedValue({
                MAPNAME: '',
                WF_ITEM_LOCATION: ''
            })
        }
    };

    useEffect(() => {
        if (openModal) {
            if (['sessionValue', 'accountData'].includes(sourceType)) {
                setLoading(true);
                dispatch(API_ENDPOINTS[sourceType].initiate({
                    account: selectedTemplate?.account || account,
                    user,
                    workflow_group_name: selectedTemplate?.workflow,
                    workflow_name: selectedTemplate?.template
                }, { forceRefetch: true }))
                    .then(res => {
                        if (res?.data?.current_state === 'SUCCESS') {
                            let data = [...res?.data?.data?.chlid || res?.data?.data?.children || res?.data?.data?.account_data_keys || []]
                            const tree = dataToRcTree(data);
                            setTreeData(tree);
                        } else setTreeData([]);
                        setLoading(false);
                    })
            } else {
                const tree = dataToRcTree(VALUE_LIST[sourceType]);
                setTreeData(tree)
            }
        }
        setSelectedKeys([]);
        setExpandedKeys([]);
        setActions({ back: true, next: false, finish: false })
    }, [openModal])

    return (
        <Dialog
            open={openModal}
            fullWidth
            maxWidth="sm"
            sx={{ overflow: "hidden" }}
        >
            <DialogTitle className="dialog-header">
                <div className="title">
                    {" "}
                    {DIALOG_TITLE[sourceType]}{" "}
                </div>
                <div className="description">
                    {" "}
                    {DIALOG_DESC_SHORT[sourceType]}{" "}
                </div>
            </DialogTitle>
            <DialogContent
                sx={{ overflow: "auto", width: "100%", padding: "0 !important" }}
                className="modal-content"
                dividers
            >
                <Box padding={"20px"} className="dialog-header">
                    <div style={{ marginBottom: '1rem', fontSize: '15px', textAlign: 'justify' }} >{DIALOG_DESC_LONG[sourceType]}</div>
                    {loading ? <Loader /> : <Box
                        sx={{
                            height: "40vh",
                            overflowX: "hidden",
                            maxHeight: "400px",
                            border: "2px solid rgba(0, 0, 0, 0.12)",
                            borderRadius: "0.2rem",
                        }}
                    >

                        {treeData?.length ?
                            <Tree
                                treeData={treeData}
                                selectedKeys={selectedKeys}
                                onSelect={onSelect}
                                onExpand={onExpand}
                                expandedKeys={expandedKeys}
                                icon={iconRender}
                                switcherIcon={switcherIcon}
                            /> : <div className="panel-no-data"> {t('NO_SESSION_DATA_AVAILABLE')} </div>}
                    </Box>}
                    {showSelection && <Box sx={{ marginTop: "10px" }}>
                        <FormControl className="width-100" size="small">
                            <TextField
                                variant="outlined"
                                size="small"
                                label={t("LBL_VALUE")}
                                type="text"
                                className={"width-100"}
                                name={"TITLE"}
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                            />
                        </FormControl>
                    </Box>}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    size='small'
                    disabled={!actions.back}
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        handleClose2(false, sourceType !== "sessionValue" ? true : false);
                        handleClose1(true);
                        setTreeData([]);
                    }}
                >
                    {" "}
                    {t("BTN_BACK")}
                </Button>
                {showSelection && <Button
                    size='small'
                    disabled={!actions.back}
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        valueHandler(selectedValue, value);
                        resetStates();
                        handleClose2(false, true);
                    }}
                >
                    {" "}
                    {t("BTN_NEXT")}
                </Button>}
                <Button
                    size='small'
                    disabled={!actions.finish}
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        valueHandler(selectedValue, value, true);
                        resetStates();
                        handleClose2(false, false);
                    }}
                >
                    {" "}
                    {t("BTN_FINISH")}
                </Button>
                <Button
                    size='small'
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        resetStates();
                        handleClose2(false, true);
                    }}
                >
                    {" "}
                    {t("BTN_CANCEL")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddWorkflowSessionValuesModal2